export const replacePath = (str: string | undefined | null): string => {
  if (!str) return '';
  const index = str.lastIndexOf('/');
  if (index < 0) return str;
  return str.substring(index + 1);
};
